// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @13.12.2018 15:04:20
import { RbacObject_abstract } from './../../abstract/SagaBase/RBAC/RbacObject_abstract';
export class RbacObject extends RbacObject_abstract {}
